module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rudMCr/tc-custom/9781504076982.jpg?1720464516835",
      "alt": "This image is the cover for the book Fatal Move, The DCI Alex Fleming Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fatal Move, The DCI Alex Fleming Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“I didn't guess whodunnit at all, so I was gripped from start to finish!” —Amazon Reviewer, five stars"), _c('br'), _c('br'), _c('b', [_vm._v("Money may make the world go round, but it turns a village upside down, in this tense British crime thriller by the author of "), _c('i', [_vm._v("The Last Man")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" The normally tranquil village of Darmont is in an uproar over a proposed building project—but the angry demonstrations by the locals are not the only thing disturbing the peace. The assistant to the millionaire property developer behind the controversy has been murdered and the son of a Saudi investor in the plan has been kidnapped."), _c('br'), _c('br'), _vm._v(" Has a protester taken things too far—or is something more sinister going on behind the scenes among the rich and powerful? As rumors and accusations of blackmail, bribery, and corruption fly, DCI Alex Fleming must dig up the truth in a pursuit that will lead him all the way to London . . .")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert McNeil\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0